import { useHooks } from './useHooks';
import BasePageLayoutWrapper from '../../components/parts/common/BasePageLayoutWrapper';
import { DailyReportListView } from '../../components/parts/dailyReport/DailyReportListView';

export const DailyReportPage: React.FC = () => {
  const { constructId, startDate, endDate } = useHooks();

  return (
    <BasePageLayoutWrapper patternName='daily_reports'>
      <DailyReportListView
        defaultConstructId={constructId}
        defaultStartDate={startDate}
        defaultEndDate={endDate}
      />
    </BasePageLayoutWrapper>
  );
};
